<template>
  <div
    v-if="videos.length"
    class="coachings-widget gw_box"
    style="--box-padding: 0"
  >
    <div class="gw_box gw_box_widget_title">
      {{ $t('coachings.upcoming_coachings') }}
      <router-link
        :to="{ name: 'Coaching', query: { tab: 'upcoming_coachings' } }"
        class="mdi mdi-chevron-right clr-white ml-auto text-large line-height_1 pa-1 icon_btn csst csst_nm"
      >
        <div
          class="csst_content text-nowrap"
          style="left: -0.25em; transform: translate(-100%, 0)"
          v-html="$t('common.see_all_coachings')"
        ></div>
      </router-link>
    </div>
    <div
      class="gw_box d-flex f-wrap"
      style="gap: 0.25rem; --box-padding: 1rem 0.5rem"
    >
      <router-link
        v-for="item in videos.filter((_, idx) => idx < 4)"
        :key="item.id"
        :to="{ name: 'Coaching', query: { tab: 'upcoming_coachings' } }"
        style="--padding: 0 0.375rem; --height: 4.5rem; --brighten-hover: 0.05"
        class="gw_btn gw_btn_text d-flex w-100 mw-o mh-0"
      >
        <FutureCoachingsBox
          :hasBtnSubText="false"
          :hasBtn="false"
          :hasTitleDate="true"
          style="
            --padding: 0;
            --gap: 1rem;
            --avatar-size: 3.5rem;
            --name-size: 0.875rem;
            --coach-size: 0.8rem;
            --title-date-size: 0.8rem;
            --tag-size: 0.7rem;
            --clr-back: transparent;
            --clr-back-hover: transparent;
            --name-line-clamp: 1;
          "
          :item="item"
        >
        </FutureCoachingsBox>
      </router-link>

      <!-- <router-link
        v-if="videos.length > 3"
        class="gw_btn gw_btn_text mt-2"
        :to="{ name: 'Coaching', query: { tab: 'upcoming_coachings' } }"
      >
        <i class="mdi mdi-human-male-board text-semi-large mr-2"></i>
        {{ $t('btn.see_all') }}
      </router-link> -->
    </div>

    <CalendarLinks
      class="bt-grey"
      :hasMessage="true"
      style="
        --size: 2.25rem;
        --size-icon: 1.5rem;
        --clr-coaching: var(--clr-primary);
        --font-size: 0.875rem;
        --font-size-message: 0.875rem;
        --padding-message: 0 0.5rem;
        --weight-message: 500;
        --item-flex-direction: row;
        --justify-content: flex-start;
        --padding-item: 0.25rem 0.5rem;
        padding: 0.75rem 0.5rem;
        gap: 0.25rem;
      "
    />
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import { getMappedCoachingItem } from '@/helpers/coachings'
import FutureCoachingsBox from '@/components/lib/FutureCoachingsBox'
import CalendarLinks from '@/components/lib/CalendarLinks'

export default {
  name: 'DashboardSocials',
  components: {
    FutureCoachingsBox,
    CalendarLinks,
  },
  mixins: [float_mix, format_mix],
  data() {
    return {}
  },
  methods: {
    hadleHelpClick(item) {
      if (item.fn) {
        item.fn()
      }
    },
    openRoadmap() {
      this.$store.dispatch('router_set_dialogs', 'roadmap-dialog')
    },
  },
  computed: {
    videoList() {
      return (this.$store.getters.api_get_data('api_coachings') || [])
        .filter(i => i?.coach)
        .filter(i => i?.coach)
    },
    videos() {
      const vids = this.videoList.map((item, idx) => {
        const r = getMappedCoachingItem({
          item,
          locale: this.$i18n.locale,
        })
        return r
      })
      let res = vids.filter(i => !i.is_past)
      res = res.sort((a, b) => (a.datetime < b.datetime ? -1 : 1))
      // console.log(res)
      res = import.meta.env.VITE_BRANCH === 'master' ? res : res.length ? res : vids
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.coachings-widget {
  min-width: 0;
}
</style>
